import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'notification.title',
    defaultMessage: 'Title',
    description: 'Label for title in notification',
  },
  priority: {
    id: 'notification.priority',
    defaultMessage: 'Priority',
    description: 'Label for priority in notification',
  },
  message: {
    id: 'notification.message',
    defaultMessage: 'Message',
    description: 'Label for message in notification',
  },
  editHeading: {
    id: 'notification.edit.heading',
    defaultMessage: 'Edit notification',
    description: 'Heading for Edit',
  },
  addHeading: {
    id: 'notification.add.heading',
    defaultMessage: 'Add a notification',
    description: 'Heading for Add',
  },
  notificationsHeading: {
    id: 'notification.heading',
    defaultMessage: 'Notifications',
    description: 'Heading for notifications list',
  },
  addNotification: {
    id: 'notification.addNotification',
    defaultMessage: 'Notification',
    description: 'Label for Add Notification button',
  },
  notFound: {
    id: 'notification.notFound',
    defaultMessage: 'Notification not found',
    description: 'Label for Notification not found',
  },
  actions: {
    id: 'notification.actions',
    defaultMessage: 'Actions',
    description: 'Label for actions in notification view table',
  },
  start: {
    id: 'notification.start',
    defaultMessage: 'Start',
    description: 'Label for start column',
  },
  end: {
    id: 'notification.end',
    defaultMessage: 'End',
    description: 'Label for end column',
  },
  userCount: {
    id: 'notification.userCount',
    defaultMessage: 'Users',
    description: 'Label for users column',
  },
  duplicateUserId: {
    id: 'notification.duplicateUserId',
    defaultMessage: 'Duplicate user selection',
    description: 'Error message for duplicate user selection',
  },
  deleteConfirm: {
    id: 'notification.deleteConfirm',
    defaultMessage: 'Yes, delete it!',
    description: 'confirm for delete alert',
  },
  deleteTitle: {
    id: 'notification.deleteTitle',
    defaultMessage: 'Are you sure?',
    description: 'title for delete alert',
  },
  deleteQuestion: {
    id: 'notification.deleteQuestion',
    defaultMessage: 'Do you really want to delete this notification?',
    description: 'question for delete alert',
  },
});

export default messages;
